import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, Subject, timer, observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { IviewedProfileViewModel } from '../../../core/models/profileModel';
import {
  IContactViewModel,
  IAddressModel,
  IViewProfileGetPriceAwardPatterView, EncryptedContactViewModel
} from '../../../core/models/accountModel';
import { DataService } from '../data.service';
import * as CryptoJS from 'crypto-js';
import { Router } from '@angular/router';
import { RfqService } from "./../../../core/services/rfq/rfq.service";
import { SSOService } from "./../../../component/SSO/services/sso.service";
import { SupplierService } from '../supplier/supplier.service';

@Injectable()
export class ProfileService {
  data = {
    "numberOfCategory": 0,
    "isOpenRfqCapabilityModel": false
  };
  private openRfqCapabilityModel = new BehaviorSubject<any>(this.data);
  private openSwitchRfqCapabilityModel = new BehaviorSubject<any>(false);
  private openShowBilling = new BehaviorSubject<any>(false);
  private buyerAiLeftNavUnlockCheckRequested = new Subject<void>();
  moduleUrl: string;
  rfqForm2Enabled: any;
  isUserGuidingEnabled: any;
  isQuoteAssistEnabled: any=null;
  isProfessionalTaken: any=null;
  isBuyerAiEnabled: any=null;
  mfgChurnkeyEnabled: boolean=false;
  key: any;
  iv: any;
  EncryptedContactViewModel: EncryptedContactViewModel;
  
  constructor(
    private _dataService: DataService,
    private router: Router,
    private _rfqService: RfqService,
    private _supplierService: SupplierService,
    private _ssoService: SSOService) {
    this.EncryptedContactViewModel = {
      id: '',
      loggedInId: 0
    };
    this.key = CryptoJS.enc.Utf8.parse('7061737323313233');
    this.iv = CryptoJS.enc.Utf8.parse('7061737323313233');
  }

  setOpenRfqCapabilityModel(flag: any) {
    this.openRfqCapabilityModel.next(flag);
  }

  getOpenRfqCapabilityModel(): Observable<any> {
    return this.openRfqCapabilityModel.asObservable();
  }


  setShowBilling(flag: any) {
    this.openShowBilling.next(flag);
  }

  getShowBilling(): Observable<any> {
    return this.openShowBilling.asObservable();
  }

  setopenSwitchRfqCapabilityModel(flag: any) {
    this.openSwitchRfqCapabilityModel.next(flag);
  }

  getopenSwitchRfqCapabilityModel(): Observable<any> {
    return this.openSwitchRfqCapabilityModel.asObservable();
  }
  getAddress(id: number): Observable<IContactViewModel> {
    this.moduleUrl = 'Contact/GetAddresses?ContactId=';
    return this._dataService.getSingle(this.moduleUrl, id);
  }


  addProfileInfo(iContactViewModel: IContactViewModel): Observable<IContactViewModel> {
    this.moduleUrl = 'Account';
    return this._dataService.add(this.moduleUrl, iContactViewModel);
  }

  updateProfileInfo(iContactViewModel: IContactViewModel): Observable<IContactViewModel> {
    this.moduleUrl = 'Contact';
    return this._dataService.UpdateWithoutId(this.moduleUrl, iContactViewModel);
  }

  addShippingAddress(iIContactViewModel: IContactViewModel): Observable<IContactViewModel> {
    this.moduleUrl = 'Contact/InsertProfileAddress';
    return this._dataService.add(this.moduleUrl, iIContactViewModel);
  }


  UpdateAddress(iShippingAddressesModel: IContactViewModel): Observable<IContactViewModel> {
    this.moduleUrl = 'Contact/UpdateAddressProfile';
    return this._dataService.UpdateWithoutId(this.moduleUrl, iShippingAddressesModel);
  }
  get loggedId() {
    // tslint:disable-next-line:radix
    return AppStorageUtil.getItem('LoggedIdEncript');
  }
  getProfileDetails(id: any, loggedId: any): Observable<any> {
    this.EncryptedContactViewModel.id = id;
    this.EncryptedContactViewModel.loggedInId = loggedId;
    this.moduleUrl = 'Contact/GetContactById';
    return this._dataService.add(this.moduleUrl, this.EncryptedContactViewModel);
  }
  getProfileForLoginDetails(id: any): Observable<any> {
    this.EncryptedContactViewModel.id = id;
    this.moduleUrl = 'Contact/GetContactById';
    return this._dataService.add(this.moduleUrl, this.EncryptedContactViewModel);
  }

  /**
   * Buyer company id for API calls: prefers storage, then Contact/GetContactById (encrypted id).
   * Persists to loggedCompanyId when fetched so later calls avoid extra round-trips.
   */
  resolveLoggedBuyerCompanyId(): Observable<number> {
    const stored = parseInt(AppStorageUtil.getItem('loggedCompanyId') || '0', 10);
    if (!Number.isNaN(stored) && stored > 0) {
      return of(stored);
    }
    const enc = AppStorageUtil.getItem('LoggedIdEncript');
    if (!enc) {
      return of(0);
    }
    return this.getProfileForLoginDetails(enc).pipe(
      map((c: any) => {
        const raw = c?.companyId ?? c?.CompanyId ?? 0;
        const n = typeof raw === 'number' ? raw : parseInt(String(raw), 10);
        return !Number.isNaN(n) && n > 0 ? n : 0;
      }),
      tap((id) => {
        if (id > 0) {
          try {
            AppStorageUtil.setItem('loggedCompanyId', String(id));
          } catch {
            /* ignore */
          }
        }
      })
    );
  }

  deleteShippingAddess(id: any): Observable<IAddressModel> {
    this.moduleUrl = 'Contact/DeleteShippingAddress?addressId=' + id + '';
    return this._dataService.deletePost(this.moduleUrl, '');
  }
  GetCompanySourcingAdvisor(companyId: number): Observable<any> {
    this.moduleUrl = 'Contact/GetCompanySourcingAdvisor?CompanyId=' + companyId;
    return this._dataService.getAll(this.moduleUrl, '');
  }
  setViewProfile(iviewedProfileViewModel: IviewedProfileViewModel): Observable<IviewedProfileViewModel> {
    this.moduleUrl = 'Contact/SetViewProfileByManufacturer';
    return this._dataService.add(this.moduleUrl, iviewedProfileViewModel);
  }
  GetRFQCountGeographicLocation(companyId: number, days: number): Observable<any> {
    this.moduleUrl = 'Contact/GetRFQCountGeographicLocation?companyId=' + companyId + '&days=' + days;
    return this._dataService.getAll(this.moduleUrl, '');
  }
  GetSubmittedRFQCount(contactId: number, rfqId: number): Observable<any> {
    this.moduleUrl = 'Contact/GetSubmittedRFQCount?contactId=' + contactId + '&rfqId=' + rfqId;
    return this._dataService.getAll(this.moduleUrl, '');
  }

  /** buyer_experience_ai: lightweight poll for left-nav unlock (mp_rfq or mp_widget_drafts). */
  getBuyerAiLeftNavUnlockHint(contactId: number): Observable<any> {
    this.moduleUrl = 'Contact/GetBuyerAiLeftNavUnlockHint?contactId=' + contactId;
    return this._dataService.getAll(this.moduleUrl, '');
  }

  /** Request an immediate left-nav unlock hint check (AdminComponent handles guards + API). */
  requestBuyerAiLeftNavUnlockCheck(): void {
    this.buyerAiLeftNavUnlockCheckRequested.next();
  }

  getBuyerAiLeftNavUnlockCheckRequests(): Observable<void> {
    return this.buyerAiLeftNavUnlockCheckRequested.asObservable();
  }

  GetStepId(contactId: number): Observable<any> {
    this.moduleUrl = 'Contact/GetSubmittedRFQCount?contactId=' + contactId;
    return this._dataService.getAll(this.moduleUrl, '');
  }
  GetPriceAwardPattern(iViewProfileGetPriceAwardPatterView: IViewProfileGetPriceAwardPatterView): Observable<any> {

    this.moduleUrl = 'Contact/GetPriceAwardPattern';
    return this._dataService.add(this.moduleUrl, iViewProfileGetPriceAwardPatterView);
  }

  GetCompanyProfile(companyName: string, scontactId: number, isBuyer: boolean, LoggedInId: number): Observable<any> {
    this.moduleUrl = 'Public/GetCompanyProfile?CompanyURL=' + companyName +
      '&IsBuyer=' + isBuyer + '&ContactId=' + scontactId + '&LoggedInId=' + LoggedInId;
    return this._dataService.getSingle(this.moduleUrl, '');
  }

  getPaymentToken(loggedInId: string): Observable<any> {
    this.moduleUrl = 'ManufacturerType?id=' + loggedInId;
    return this._dataService.getSingle(this.moduleUrl, '');
  }
  getAccountType() {
    if (AppStorageUtil.getItem('AccountType') === 'Basic') {
      return 1;
    } else {
      return 2;
    }
  }

  // Get product Stripe capability
  getStripeProductsCapability(): Observable<any> {
    this.moduleUrl = 'GrowthPackage/GetGrowthPackageProductCapabilities';
    return this._dataService.getAll(this.moduleUrl, '');
  }
  // Save subscribe capability
  stripeHostedPaymentPage(requestData): Observable<any> {
    this.moduleUrl = 'StripeHostedPaymentPages';
    return this._dataService.add(this.moduleUrl, requestData);
  }
  // open starter page subscribe capability
  starterStripeHostedPaymentPage(requestData): Observable<any> {
    this.moduleUrl = 'StripeStarterTrialHostedPaymentPages';
    return this._dataService.add(this.moduleUrl, requestData);
  }

  // UpDate PaymentPage Status
  updatePaymentPage(requestData): Observable<any> {
    this.moduleUrl = 'StripeHostedPaymentPages/UpdateStripeHostedPaymentPageSuccessStatus';
    return this._dataService.add(this.moduleUrl, requestData);
  }


  encrypt(input: any) {
    if (input !== null) {
      const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(input), this.key, {
        keySize: 128 / 8,
        iv: this.iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted;
    }
  }
  decrypt(input: any) {
    if (input !== null) {
      const decrypted = CryptoJS.AES.decrypt(input, this.key, {
        keySize: 128 / 8,
        iv: this.iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      const orstr = decrypted.toString(CryptoJS.enc.Utf8);
      return orstr;
    }
  }

  getConfigCatData(): Observable<any> {
    return new Observable((observer) => {
      if (this.rfqForm2Enabled !== undefined) {
        observer.next(this.rfqForm2Enabled);
        return;
      }
      this._dataService.getAll("FeatureFlag?key=isNewBuyerFormEnabled&email=" + AppStorageUtil.getItem('User2')).
        subscribe(
          configCatData => {
            this.rfqForm2Enabled = Boolean(configCatData["isFeatureOn"]);
            observer.next(this.rfqForm2Enabled);
          },
          error => {
            observer.next(this.rfqForm2Enabled);
          });
    });
  }
  getStripePriceData(): Observable<any> {
    this.moduleUrl = 'StripeCustomerPortal/GetStripePrice';
    return this._dataService.getAll(this.moduleUrl, '');
  }
  redirectToNewBuyer(url, parameter = "") {
    const querySuffix = parameter
      ? (parameter.startsWith('?') ? parameter : '?' + parameter)
      : '';
    const u = url || '';
    if (u.includes('myrfq') || u.includes('filter=toAwarded')) {
      this.router.navigateByUrl(u);
      return;
    }
    if (u.includes('editrfq')) {
      this.router.navigateByUrl(u + querySuffix);
      return;
    }

    // New buyers (0 RFQs) must land on the dashboard first so the onboarding popup
    // can show once; after submit, buyer-onboarding navigates to RFQ AI / classic form.
    if (u === 'getStarted' || u.includes('getStarted')) {
      this.router.navigateByUrl('/dashboard/buyer/default');
      return;
    }

    this.getConfigCatBuyerAiData().subscribe(buyerAi => {
      if (buyerAi) {
        this.router.navigateByUrl('rfq/rfq-ai' + querySuffix);
        return;
      }
      if (this.rfqForm2Enabled !== undefined) {
        if (this.rfqForm2Enabled) {
          this.router.navigateByUrl('rfq/buyer' + querySuffix);
        } else {
          this.router.navigateByUrl(url);
        }
        return;
      }
      this._dataService.getAll("FeatureFlag?key=isNewBuyerFormEnabled&email=" + AppStorageUtil.getItem('User2')).
        subscribe(
          configCatData => {
            this.rfqForm2Enabled = Boolean(configCatData["isFeatureOn"]);
            if (this.rfqForm2Enabled) {
              this.router.navigateByUrl('rfq/buyer' + querySuffix);
            } else {
              this.router.navigateByUrl(url);
            }
          },
          error => {
          });
    });
  }

  getConfigCatUserGuidingData(): Observable<any> {

    return new Observable((observer) => {
      this._dataService.getAll("FeatureFlag?key=isUserguidingEnabled&email=" + AppStorageUtil.getItem('User2')).
        subscribe(
          configCatData => {
            this.isUserGuidingEnabled = Boolean(configCatData["isFeatureOn"]);
            observer.next(this.isUserGuidingEnabled);
          },
          error => {
            observer.next(this.isUserGuidingEnabled);
          });
    });
  }
  emitIsQuoteAssistEnabled(timerSubscription, observer) {
    if (timerSubscription == null) {
        observer.next({isQuoteAssistEnabled: this.isQuoteAssistEnabled, isProfessionalTaken: this.isProfessionalTaken});
        observer.complete();
    }
  }
  getConfigCatQuoteAssistData(): Observable<{isQuoteAssistEnabled: boolean, isProfessionalTaken: boolean}> {
    return new Observable((observer) => {
      
      const loadingText = "Loading";
      if (this.isQuoteAssistEnabled != null && this.isQuoteAssistEnabled != loadingText) {
        observer.next({isQuoteAssistEnabled: this.isQuoteAssistEnabled, isProfessionalTaken: this.isProfessionalTaken});
        observer.complete();
        return;
      }
      let timerSubscription = null;
      if (this.isQuoteAssistEnabled === loadingText) {
        timerSubscription = timer(2000, 1000).subscribe(() => {
          if (this.isQuoteAssistEnabled != null && this.isQuoteAssistEnabled != loadingText) {
            timerSubscription.unsubscribe();
            timerSubscription = null;
  
            observer.next({isQuoteAssistEnabled: this.isQuoteAssistEnabled, isProfessionalTaken: this.isProfessionalTaken});
            observer.complete();
            return;
          }
        })
      }
      this.isQuoteAssistEnabled = loadingText;
      let userEmail =  AppStorageUtil.getItem('User2');
      if(userEmail){
        userEmail = userEmail.toLowerCase();
      }
      const url="FeatureFlag?key=subscriptionfeature&email=" + AppStorageUtil.getItem("loggedCompanyId");

      this._dataService.getAll(url).
        subscribe(
          configCatData => {
            this.isQuoteAssistEnabled = Boolean(configCatData["isQuoteAssistEnabled"]);
            this.isProfessionalTaken = Boolean(configCatData["isProfessionalTaken"]);
            this.emitIsQuoteAssistEnabled(timerSubscription, observer);
          },
          error => {
            this.isQuoteAssistEnabled = false;
            this.isProfessionalTaken = false;
            this.emitIsQuoteAssistEnabled(timerSubscription, observer);
          });
    });
  }

  getConfigCatBuyerAiData(forceRefresh: boolean = false): Observable<boolean> {
    return new Observable((observer) => {
      if (!forceRefresh && this.isBuyerAiEnabled !== null) {
        observer.next(this.isBuyerAiEnabled);
        observer.complete();
        return;
      }
      const url = "FeatureFlag?key=buyer_experience_ai&email=" + AppStorageUtil.getItem("loggedCompanyId");
      this._dataService.getAll(url).subscribe(
        configCatData => {
          this.isBuyerAiEnabled = Boolean(configCatData["isFeatureOn"]);
          observer.next(this.isBuyerAiEnabled);
          observer.complete();
        },
        error => {
          this.isBuyerAiEnabled = false;
          observer.next(this.isBuyerAiEnabled);
          observer.complete();
        });
    });
  }

  validateUserAndGenerateToken(contactId): Observable<any> {
    return new Observable(observable => {
      try {
        this._supplierService.GetSupplierInfoForMaterialRedirection(contactId, AppStorageUtil.getItem('User2')).subscribe((response: any) => {
          if (!response) {
            observable.next({ status: false, lineNo: 282 });
            return;
          }
          observable.next({ status: true, token: response });
        })
      } catch (error) {
        observable.next({ status: false, lineNo: 307 });
      }
    });
  }
  loadUserDetail(): Observable<boolean> {
    return new Observable(observable=>{
      const loggedUserId=AppStorageUtil.getItem('LoggedIdEncript');
      if(!loggedUserId){
        observable.next(false);
        observable.complete(); 
        return;
      }
      this._dataService.add('Contact/GetContactById', {id:loggedUserId}).subscribe(
        response=>{
        AppStorageUtil.setItem('iContactViewModel', JSON.stringify(response));
        observable.next(true);
        observable.complete(); 
      },error=>{
        observable.next(false);
        observable.complete(); 
        return;
      })
    });
  }  

  saveTrackingData(trackingData: any): Observable<any> {
    this.moduleUrl = 'supplier/SaveQASupplierRfqQuoteTracking';
    return this._dataService.quoteAssistPost(this.moduleUrl, trackingData);
  }
  getProfessionalPackageDetail(loggedId: number): Observable<any>  {
    this.moduleUrl = 'ProfessionalPackage/GetProfessionalPackageCompany/' + loggedId;
    return this._dataService.getAll(this.moduleUrl, '');
  }
  getLeftMenuItems(): Observable<any> {
    this.moduleUrl = 'Account/GetMenuDetails?contactId=' + AppStorageUtil.getLoogedUserId();
    return this._dataService.getAll(this.moduleUrl, '');
  }
  
  getCommunityProfile(companyId: number): Observable<any> {
    this.moduleUrl = 'CommunityProfile/GetCommunityProfile?companyId=' + companyId;
    return this._dataService.getAll(this.moduleUrl, '');
  }
  getLaunchWebsiteTileData(companyId: number,contactId: number): Observable<any> {
    this.moduleUrl = 'Supplier/GetWebsiteProgress?companyId='+companyId + '&contactId='+contactId;
    return this._dataService.getAll(this.moduleUrl, '');
  }
  claimFreeRfq(requestData): Observable<any> {
    this.moduleUrl = 'supplier/ClaimWebsitePublishReward';
    return this._dataService.add(this.moduleUrl, requestData);
  }
  logRfqFileClick(requestData): Observable<any> {
    this.moduleUrl = 'rfq/LogRfqFileClick';
    return this._dataService.add(this.moduleUrl, requestData);
  }
  getUnquotedRFQsList(companyId: number): Observable<any> {
    this.moduleUrl = 'supplier/GetSupplierMatchingOpportunities?companyId=' + companyId;
    return this._dataService.getAll(this.moduleUrl, '');
  }
  getOnboardingChecklist(companyId: number,contactId: number): Observable<any> {
    this.moduleUrl = 'supplier/GetOnboardingChecklist?companyId=' + companyId + '&contactId=' + contactId;
    return this._dataService.getAll(this.moduleUrl, '');
  }
  updateOnboardingChecklist(checklistItems: any): Observable<any> {
    this.moduleUrl = 'supplier/UpdateChecklistStep'
    return this._dataService.add(this.moduleUrl, checklistItems);
  }

  // Get Stripe prices by product ID
  getStripeProductPrices(activeOnly: boolean = true): Observable<any> {
    this.moduleUrl = 'StripePrice/GetPricesByProductSearch?activeOnly=' + activeOnly;
    return this._dataService.getAll(this.moduleUrl, '');
  }

  // Get Stripe prices by product ID
  getStripeProductPricesByProductId(productId: string, activeOnly: boolean = true): Observable<any> {
    this.moduleUrl = 'StripePrice/GetPricesByProduct';
    const requestData = {
      productId: productId,
      activeOnly: activeOnly
    };
    return this._dataService.add(this.moduleUrl, requestData);
  }


  getConfigCatChurnkeyEnabled(companyId: number): Observable<boolean> {
    return new Observable((observer) => {
      const url =
        "FeatureFlag?key=mfg_churnkey&email=" + String(companyId);
      this._dataService.getAll(url).subscribe(
        (configCatData) => {
          this.mfgChurnkeyEnabled = Boolean(configCatData["isFeatureOn"]);
          observer.next(this.mfgChurnkeyEnabled);
        },
        () => {
          this.mfgChurnkeyEnabled = false;
          observer.next(this.mfgChurnkeyEnabled);
        }
      );
    });
  }

}